import { useMemo } from "react"
import PropTypes from "prop-types"
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { useAnalytics } from "connected-components/analytics"
import { AI_TEAMMATE_EVENTS } from "../../analytics"
import { useAiTeammateContext } from "../../hooks/context"

function ConfirmResetDialog({ parentContainer, isOpen, onClose }) {
  const { resetContext } = useAiTeammateContext()
  const analytics = useAnalytics()
  const parentContainerRef = useMemo(() => parentContainer.current, [parentContainer])

  function handleReset() {
    resetContext()
    analytics.track(AI_TEAMMATE_EVENTS.THREAD_RESET)
    onClose()
  }

  return <Dialog open={isOpen} onClose={onClose} container={parentContainerRef}>
    <DialogTitle>Reset chat</DialogTitle>
    <DialogContent>
      <DialogContentText>Are you sure you want to reset the chat and lose all your history?</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button color="secondary" onClick={onClose}>Cancel</Button>
      <Button color="error" onClick={handleReset}>Reset</Button>
    </DialogActions>
  </Dialog>
}

ConfirmResetDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  parentContainer: PropTypes.element,
}

export default ConfirmResetDialog
